import ChatCastingSearchFields, { emptyChatCastingFilter } from './ChatCastingSearchFields';
import React from 'react';
import DsSwitch from '../../common/DsSwitch';
import DsModal from '../../common/DsModal';
import ChatTargetSearchModal from '../../common/chat/search/ChatTargetSearchModal';
import DsSelect from '../../common/DsSelect';

export function ChatPageSearchModal({
  isOpen,
  onClose,
  onApply,
  onClear,
  summary,
  searchDraft,
  setSearchDraft,
  parts,
  groups,
}) {
  return (
    <ChatTargetSearchModal
      isOpen={isOpen}
      title="チャット検索"
      onClose={onClose}
      onApply={onApply}
      onClear={onClear}
      summary={summary}
    >
      <div className="chat-target-search-form">
        <div className="chat-target-search-form__field">
          <label className="chat-target-search-form__label" htmlFor="chat-search-name">
            アーティスト名
          </label>
          <input
            id="chat-search-name"
            className="chat-target-search-form__input"
            type="text"
            value={searchDraft.name}
            onChange={(event) =>
              setSearchDraft((current) => ({ ...current, name: event.target.value }))
            }
            placeholder="名前で絞り込み"
          />
        </div>

        <div className="chat-target-search-form__field">
          <label className="chat-target-search-form__label" htmlFor="chat-search-part">
            パート
          </label>
          <DsSelect
            id="chat-search-part"
            className="chat-target-search-form__select"
            value={searchDraft.part}
            onChange={(event) =>
              setSearchDraft((current) => ({ ...current, part: event.target.value }))
            }
          >
            <option value="">すべて</option>
            {parts.map((part) => (
              <option key={part.value} value={part.label}>
                {part.label}
              </option>
            ))}
          </DsSelect>
        </div>

        <div className="chat-target-search-form__field">
          <label className="chat-target-search-form__label" htmlFor="chat-search-group">
            グループ
          </label>
          <DsSelect
            id="chat-search-group"
            className="chat-target-search-form__select"
            value={searchDraft.group}
            onChange={(event) =>
              setSearchDraft((current) => ({ ...current, group: event.target.value }))
            }
          >
            <option value="">すべて</option>
            {groups.map((group) => (
              <option key={group.group_id} value={String(group.group_id)}>
                {group.group_name}
              </option>
            ))}
          </DsSelect>
        </div>

        <ChatCastingSearchFields value={searchDraft.casting || emptyChatCastingFilter} onChange={(casting) => setSearchDraft(current => ({ ...current, casting }))} />
        <div className="chat-target-search-form__field">
          <label className="chat-target-search-form__label" htmlFor="chat-search-message">
            チャット本文
          </label>
          <input
            id="chat-search-message"
            className="chat-target-search-form__input"
            type="text"
            value={searchDraft.message}
            onChange={(event) =>
              setSearchDraft((current) => ({ ...current, message: event.target.value }))
            }
            placeholder="本文キーワード"
          />
        </div>
      </div>
    </ChatTargetSearchModal>
  );
}

export function ChatPageSettingsModal({
  isOpen,
  onClose,
  settingsArtist,
  selectedArtist,
  isNicknameAllowed,
  onNicknamePermissionChange,
  isReadNotifyEnabled,
  onReadNotifyToggle,
  readToggleLoading,
  artistChatMuted,
  onArtistMuteToggle,
  artistChatMuteLoading,
  readNotifyFetching,
  readEnabledAdmins,
}) {
  if (!isOpen) return null;

  const artistName = settingsArtist?.name || selectedArtist?.name || 'アーティスト';

  return (
    <DsModal
      open={isOpen}
      onClose={onClose}
      title="チャット設定"
      size="sm"
      className="chat-settings-modal"
    >
        <p className="settings-modal__target" aria-label="設定対象">
          <span>対象</span>
          <strong>{artistName}</strong>
        </p>
        <div className="settings-modal__body">
          <div className="settings-modal__section">
            <div className="settings-modal__section-text">
              <p className="settings-modal__label">ニックネーム表示</p>
              <p className="settings-modal__description">許可している相手には自分のニックネームで表示されます。</p>
            </div>
            <DsSwitch
              checked={isNicknameAllowed}
              onChange={onNicknamePermissionChange}
              onError={() => {}}
              ariaLabel="ニックネームを許可する"
            />
          </div>
          <div className="settings-modal__section">
            <div className="settings-modal__section-text">
              <p className="settings-modal__label">既読通知</p>
              <p className="settings-modal__description">オンの管理者だけがチャット閲覧時に既読を送信します。</p>
            </div>
            <DsSwitch
              checked={isReadNotifyEnabled}
              onChange={onReadNotifyToggle}
              onError={() => {}}
              disabled={readToggleLoading || !(settingsArtist || selectedArtist)}
              ariaLabel="既読通知のオンオフ"
            />
          </div>
          <div className="settings-modal__section">
            <div className="settings-modal__section-text">
              <p className="settings-modal__label">通知オン</p>
              <p className="settings-modal__description">オフにすると、このアーティストとのチャット通知（メール/LINE/プッシュ）を受け取りません。</p>
            </div>
            <DsSwitch
              checked={!artistChatMuted}
              onChange={onArtistMuteToggle}
              onError={() => {}}
              disabled={artistChatMuteLoading || !(settingsArtist || selectedArtist)}
              ariaLabel="このアーティストの通知オンオフ"
            />
          </div>
          <div className="settings-modal__read-meta">
            <div className="settings-modal__read-header">
              <p className="settings-modal__description">既読通知をオンにしている管理者</p>
              {readToggleLoading && <span className="settings-modal__status">更新中…</span>}
            </div>
            {readNotifyFetching ? (
              <p className="settings-modal__muted">読み込み中です…</p>
            ) : readEnabledAdmins.length ? (
              <ul className="settings-modal__read-admins">
                {readEnabledAdmins.map((admin) => (
                  <li key={admin.adminUserId || admin.displayName}>
                    {admin.full_name || admin.displayName || `ID: ${admin.adminUserId}`}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="settings-modal__muted">まだオンにしている管理者はいません。</p>
            )}
          </div>
        </div>
    </DsModal>
  );
}
